export interface Rule {
  id: number;
  ruleName: string;
  ruleNumber: string;
  classificationRule: number;
}

export function getDisposeStatementName(disposeStatement: number): string {
  switch (disposeStatement) {
    case 0:
      return "处理中";
    case 1:
      return "已完成";
  }
  return "";
}
export function getDisposeStateQuery(disposeStatement: number): string {
  switch (disposeStatement) {
    case 1:
      return "未处理";
    case 2:
      return "已完成";
  }
  return "";
}

export function getDisposeStatusName(disposeStatus: number): string {
  switch (disposeStatus) {
    case 0:
      return "未处理";
    case 1:
      return "处理中";
    case 2:
      return "已完成";
    case 3:
      return "无需处理";
    case 8:
      return "数据校验失败";
    case 9:
      return "风险解除";
  }
  return "";
}

export function getRiskName(cautionLevel: any): string {
  switch (cautionLevel) {
    case "P0":
      return "高风险";
    case "P1":
      return "较高风险";
    case "P2":
      return "中风险";
    case "P3":
      return "低风险";
  }
  return "";
}
export function getDisposeResultName(result: number): string {
  switch (result) {
    case 0:
      return "无需处置";
    case 1:
      return "风险监测预警提示";
    case 3:
      return "创建检查任务";
    case 4:
      return "风险下发";
  }
  return "";
}
